import classNames from 'classnames'

import styles from './styles/Card.css'

const Card = ({ className = '', children, level = 1, onClick, selected = false, ...rest }) => {
  const extraProps = onClick
    ? {
        onClick,
        role: 'button',
        tabIndex: 0
      }
    : {}

  return (
    <div
      className={classNames(styles.card, {
        [styles.levelZero]: level === 0,
        [styles.levelOne]: level === 1,
        [styles.levelTwo]: level === 2,
        [styles.levelThree]: level === 3,
        [styles.levelFour]: level === 4,
        [styles.clickable]: !!onClick,
        [styles.selected]: selected
      }, className)}
      {...extraProps}
      {...rest}
    >
      {children}
    </div>
  )
}

export default Card
